<template>
  <div>
    <v-menu offset-y close-on-click content-class="rounded-lg mt-2">
      <template #activator="{ on, attrs }">
        <v-btn
          class="action-text text-none"
          :class="classes"
          :color="color"
          rounded
          small
          elevation="0"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon class="material-icons-outlined mr-1" small>
            place
          </v-icon>
          {{ text }}
          <v-icon>arrow_drop_down</v-icon>
        </v-btn>
      </template>
      <v-list rounded>
        <v-list-item
          v-for="option in options"
          :key="option"
          dense
          @click="onSelect(option)"
        >
          <v-list-item-title>
            {{ option }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { FileSource } from '@/enums';
export default {
  name: 'FileSourceControls',
  props: {
    value: {
      type: String,
      default: FileSource.OTHER,
    },
  },
  computed: {
    options() {
      return Object.values(FileSource)
        .filter((value) => value !== this.value)
        .map((value) => this.enumToDisplayName(value));
    },
    text() {
      if (!this.value) {
        return 'Select file source';
      }
      return this.enumToDisplayName(this.value);
    },
    classes() {
      return {
        'grey--text': this.isOther,
        'text--darken-1': this.isOther,
        'white--text': !this.isOther,
      };
    },
    color() {
      return this.isOther ? 'grey lighten-2' : 'primary';
    },
    isOther() {
      return !this.value || this.value === FileSource.OTHER;
    },
  },
  methods: {
    onSelect(option) {
      this.$emit('input', option.toUpperCase());
    },
    enumToDisplayName(option) {
      return (
        option.charAt(0).toUpperCase() + option.slice(1).toLowerCase()
      );
    },
  },
};
</script>
